import cx from 'classnames';
import React from 'react';

import { MenuItem, Select } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import styles from './SortBySelect.module.scss';

type SortBySelectProps = {
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

const SortBySelect = ({ value, onChange, className }: SortBySelectProps) => (
  <div className={cx(styles.sortby, className)}>
    <Select
      displayEmpty
      IconComponent={KeyboardArrowDownIcon}
      value={value}
      onChange={e => onChange(e.target.value as string)}
    >
      <MenuItem value="">Sort by</MenuItem>
      <MenuItem value={'MostRecent'}>Recently added</MenuItem>
      <MenuItem value={'HighestPaid'}>Highest paid</MenuItem>
    </Select>
  </div>
);

export default SortBySelect;
